import * as React from 'react';
import "./styles/app.css";
import type { Metadata } from './types/metadata';
import AppRoutes from "./routes";
import { ThemeProvider } from './components/core/theme-provider/theme-provider';
import GlobalStyle from "./styles/globalStyles";
import { getSettings as getPersistedSettings } from './lib/settings/get-settings';
import { SettingsProvider } from './contexts/settings';
import { BrowserRouter as Router } from "react-router-dom";
import { ReactTagManager } from 'react-gtm-ts';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { config } from "./config";
import { gtag } from '../src/functions/misc';
import { withLDProvider } from 'launchdarkly-react-client-sdk';

const metadata: Metadata = { title: config.site.name };

ReactTagManager.init({
    code: 'GTM-5C65XM3', // GTM Code
    debug: false, // debug mode (default false)
});

gtag('config', '4759939415', {
  'cookie_flags': 'SameSite=None;Secure'
});

function App() {
	const settings = getPersistedSettings();
  return (
    <Router>
    <HelmetProvider>
    <Helmet>
				<title>{metadata.title}</title>
				<meta content={config.site.themeColor} name="theme-color" />
			</Helmet>
      <SettingsProvider settings={settings}>
        <ThemeProvider>
          <GlobalStyle />  
            <AppRoutes />   
        </ThemeProvider>
      </SettingsProvider>
    </HelmetProvider>
    </Router>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCHDARKLY_ID ?? '',
})(App);